import React, { useState, useEffect } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import PhotoModal from "../WidgetsSettings/PhotoWidget/PhotoModal";
import { getListV2 } from "../../../services/api/Api";
import { getLabelFromTechName } from "../../Newsletter/NewsletterSteps/ThirdStep";
import { Message, Spin } from "../../BP2Components";
import { useIntl } from "react-intl";
import "../WidgetsSettings/PhotoWidget/photo.less";
import { getConnectionData } from "../../../util/Scripts";

interface PhotoWidgetProps {
   value: any;
   role: any;
}

const PhotoWidget: React.FC<PhotoWidgetProps> = ({ value, role }) => {
   const [imgSource, setImgSource] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const intl = useIntl();

   useEffect(() => {
      let connectionFilter;
      connectionFilter = getConnectionData(value.id);
      if (connectionFilter) {
         setIsLoading(true);
         getListV2(value.listId, 1, 10, connectionFilter).then((res) => {
            let fileUrl = null;
            const photoLabel = getLabelFromTechName(
               value?.photoTechName || "UsersInfo_desktop_izsc4e",
               res?.data?.default?.columns
            );
            res?.data?.default?.data?.map((item) => {
               fileUrl =
                  item?.[photoLabel][0]?.altUrl ??
                  item?.[photoLabel][0]?.altUrl1 ??
                  item?.[photoLabel][0]?.fileUrl;
            });
            if (fileUrl) {
               setImgSource(fileUrl);
               setIsLoading(false);
            } else {
               Message.error(intl.formatMessage({ id: "global.error" }));
               setIsLoading(false);
            }
         });
      } else if (value.listId && value.dataId && value.photoTechName) {
         setIsLoading(true);
         getListV2(value.listId, 1)
            .then((res) => {
               const photoLabel = getLabelFromTechName(
                  value?.photoTechName,
                  res?.data?.default?.columns
               );
               const id = getLabelFromTechName("id", res?.data?.default?.columns);

               let fileUrl = null;
               res?.data?.default?.data?.map((item) => {
                  if (item[id] === value.dataId) {
                     fileUrl =
                        item?.[photoLabel][0]?.altUrl ??
                        item?.[photoLabel][0]?.altUrl1 ??
                        item?.[photoLabel][0]?.fileUrl;
                  }
               });
               if (fileUrl) {
                  setImgSource(fileUrl);
                  setIsLoading(false);
               } else {
                  Message.error(intl.formatMessage({ id: "global.error" }));
                  setIsLoading(false);
               }
            })
            .catch((err) => {
               Message.error(intl.formatMessage({ id: "global.error" }));
               setIsLoading(false);
            });
      }
   }, [value]);

   return (
      <>
         <Widget
            className="photo-widget"
            bgColor={value.backgroundColourHex}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  //@ts-ignore
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={<PhotoModal value={value} />}
                  />
               )
            }
            children={
               <div className="photo-container">
                  {isLoading ? (
                     <Spin />
                  ) : (
                     imgSource !== "" && (
                        <img src={imgSource} alt="photo" className="widget-image" />
                     )
                  )}
               </div>
            }
         ></Widget>
      </>
   );
};

export default PhotoWidget;
